"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardanoWalletName = void 0;
var CardanoWalletName;
(function (CardanoWalletName) {
    // CIP-30
    CardanoWalletName["NAMI"] = "nami";
    CardanoWalletName["FLINT"] = "flint";
    CardanoWalletName["CARDWALLET"] = "cardwallet";
    CardanoWalletName["TYPHON"] = "typhon";
    CardanoWalletName["ETERNL"] = "eternl";
    CardanoWalletName["GEROWALLET"] = "gerowallet";
    CardanoWalletName["NUFI"] = "nufi";
    // other
    CardanoWalletName["YOROI"] = "yoroi";
})(CardanoWalletName || (exports.CardanoWalletName = CardanoWalletName = {}));
